<template>
  <div
    class="full-height d-flex flex-column"
  >
    <profile-app-bar
      :title="$route.meta.appBarTitle || $route.meta.documentTitle"
      :prev-page="prevPage"
      :show-drop-down="false"
    />

    <router-view />
  </div>
</template>

<script>
import ProfileAppBar from '../components/ProfileAppBar.vue';

export default {
  components: {
    ProfileAppBar,
  },

  computed: {
    prevPage() {
      if (this.$route.path === '/admin') return null;
      return '/admin';
    },
  },
};
</script>
